/**
 * Converts an object into a URL query string.
 * Values are automatically URL encoded.
 *
 * @param params - Object containing key-value pairs to convert to query parameters
 * @param initialPrefix - Optional prefix to prepend to the query string ('?', '&', or '')
 * @returns Formatted query string starting with the specified prefix
 *
 * @example
 * // Returns "?name=John&age=30"
 * objectToQueryParams({name: "John", age: "30"}, "?")
 */
export const objectToQueryParams = (
  params: Record<string, string>,
  initialPrefix: "?" | "&" | "" = "",
): string => {
  const flattenObject = (
    obj: Record<string, string>,
    prefix = "",
  ): string[] => {
    return Object.entries(obj).reduce((acc: string[], [key, value]) => {
      const paramKey = prefix ? `${prefix}[${key}]` : key;

      if (value === null || value === undefined) {
        return acc;
      }

      return acc.concat(`${paramKey}=${encodeURIComponent(value)}`);
    }, []);
  };

  return initialPrefix + flattenObject(params).join("&");
};
